import Textfield from '@atlaskit/textfield';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from '../../../../../messages/sign-up-form';
import {
  ErrorMessageWithDefaultClassName,
  FullNameFieldWrapper,
  Label,
  NameFieldGroup
} from './styled';

export type DisplayNameProps = {
  readonly onNameChange: (displayName: string | null) => void;
  readonly displayname: string | null | undefined;
  readonly isDisabled: boolean;
  readonly fadeOnDisable?: boolean;
  readonly outlineOnFocus?: boolean;
  readonly popOverError?: boolean;
};

const nonValidNamePattern =
  /((http(s)?|ftp|callto|mailto|skype|magnet):)|www\.|:\/\/|@|\$|^\s+$/i;

export function DisplayNameField({
  onNameChange,
  displayname,
  isDisabled,
  fadeOnDisable,
  popOverError,
  outlineOnFocus
}: DisplayNameProps) {
  const checkIsDisabled = () => {
    // ensure isDisabled can be set when form is submitting,
    return isDisabled;
  };
  const [alreadySentValid, setAlreadySentValid] = useState(false);
  const [displayName, setDisplayName] = useState(
    displayname ? displayname : ''
  );
  const [isValidDisplayName, setIsValidDisplayName] = useState(true);
  const [isWithinMaxLength, setIsWithinMaxLength] = useState(true);
  const [isDisplayNameFocused, setIsDisplayNameFocused] = useState(false);
  const [fieldDisabled, setFieldDisabled] = useState(checkIsDisabled());

  useEffect(() => {
    isValidDisplayName && isWithinMaxLength
      ? onNameChange(displayName)
      : onNameChange('');

    if (
      isValidDisplayName &&
      isWithinMaxLength &&
      displayName.length > 0 &&
      !alreadySentValid
    ) {
      setAlreadySentValid(true);
    }
  }, [displayName]);

  useEffect(() => {
    setFieldDisabled(checkIsDisabled());
  }, [isDisabled]);

  const updateDisplayName = (event: React.FormEvent<HTMLInputElement>) => {
    const value: string = event.currentTarget.value;
    setDisplayName(event.currentTarget.value);
    setIsValidDisplayName(true);
    setIsWithinMaxLength(true);

    if (value.match(nonValidNamePattern)) {
      setIsValidDisplayName(false);
    } else if (value.length > 255) {
      setIsWithinMaxLength(false);
    }
  };

  return (
    <FullNameFieldWrapper className={'full-name-field sign-up-field-container'}>
      <NameFieldGroup
        isValid={isValidDisplayName && isWithinMaxLength}
        val={displayName}
        outlineOnFocus={outlineOnFocus}
        isFocused={isDisplayNameFocused}
        isDisabled={fieldDisabled}
        fadeOnDisable={fadeOnDisable}
      >
        <Label>
          <FormattedMessage {...messages.fullNameLabel} />
        </Label>
        <Textfield
          className={'full-name-field first-name input'}
          value={displayName}
          style={{ height: 'inherit' }}
          onChange={updateDisplayName}
          isDisabled={fieldDisabled}
          onFocus={() => setIsDisplayNameFocused(true)}
          onBlur={() => setIsDisplayNameFocused(false)}
        />
      </NameFieldGroup>
      {!isValidDisplayName && (
        <ErrorMessageWithDefaultClassName
          isDisabled={fieldDisabled}
          fadeOnDisable={fadeOnDisable}
          popOverError={popOverError}
        >
          <FormattedMessage {...messages.errorName} />
        </ErrorMessageWithDefaultClassName>
      )}
      {!isWithinMaxLength && (
        <ErrorMessageWithDefaultClassName
          isDisabled={fieldDisabled}
          fadeOnDisable={fadeOnDisable}
          popOverError={popOverError}
        >
          <FormattedMessage {...messages.errorNameLength} />
        </ErrorMessageWithDefaultClassName>
      )}
    </FullNameFieldWrapper>
  );
}
